import SwastikImg from "../images/swastik.jpeg";
import ChaduvlaImg from "../images/chaduvula.jpeg";
import RakeshImg from "../images/rakesh.jpeg";

export const creators = [
  {
    img: SwastikImg,
    name: 'Swastik Yadav',
    role: 'Creator | Host',
    link: 'https://twitter.com/codeSwastik'
  },
  {
    img: ChaduvlaImg,
    name: 'Chaduvla Prasanth',
    role: 'Creator | Host',
    link: 'https://twitter.com/chaduvula98'
  },
  {
    img: RakeshImg,
    name: 'Rakesh Kumar',
    role: 'Creator | Host',
    link: 'https://twitter.com/rkrkumar021'
  }
];